import { GenericEntityBase, KeyType } from "../../_models/GenericEntityBase";
import { IPropretyAttribute } from "../../_models/IEntityMetaData";
import { PropretyAttributes, Validation } from "../../decorators/EntityDecorators";
import { IEntityMetaData } from "../../_models/IEntityMetaData";
import { Register } from "../../decorators/DependencyInjectionRegistreyDecorators";


@Register({
  isModelEntity: true, namespace: 'Tenant' ,  entityName: 'Role' // optionnel car par defaut utilise le nom de classe
})
export class Role extends GenericEntityBase<number> {

    @PropretyAttributes({
        attributes: [
            IPropretyAttribute.KeyProperty,
            IPropretyAttribute.Readonly
        ]
    })
    id: number = GenericEntityBase.GetDefaultId(KeyType.number);
    @PropretyAttributes({ attributes: [IPropretyAttribute.Required, IPropretyAttribute.SortColumn, IPropretyAttribute.FilterColumn] })
    @Validation({ maxLength: 255 })
    title?: string;

    defaultPermissions!: string;

    GetType(): IEntityMetaData {
        return Role.getMetaData();
    }

}

// Créer des classes spécifiques pour chaque type de rôle
export class TenantRole extends Role {
    static override getMetaData(): IEntityMetaData {
        const baseMetaData = super.getMetaData();
        return {
            ...baseMetaData,
          EndPoint: "/tenantRoles",
          Namespace: 'Tenant',
          EntityName: 'Role'
        };
    }
}
export class ManagerRole extends Role {
    static override getMetaData(): IEntityMetaData {
        const baseMetaData = super.getMetaData();
        return {
            ...baseMetaData,
          EndPoint: "/managerRoles",
          Namespace: 'Manager',
          EntityName: 'Role'
        };
    }
}
